


























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import THead from '@/components/Table/THead.vue';
import TBody from '@/components/Table/TBody.vue';

@Component({
	components: {
		THead,
		TBody,
	},
})
export default class Table extends Vue {
	private tableState: string = 'VIEW';
	@Prop() private rows!: any;
	@Prop() private columns!: any;
	@Prop() private selectedColumn!: any;

	private updated() {		
		if (this.selectedColumn) {
			const elem = (this.$refs.tablehead as any).getSelected();
			if (elem) {
				(this.$refs.tableScroll as Element).scroll(elem.offsetLeft - 35, 0);								
			}
		}
	}
}
